export default {"src":"/_next/static/media/elf.8b505b11.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};